"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxTable = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _BasePrice = require("b2b-components/theme/components/BasePrice");
var _Price = require("b2b-components/theme/components/Price");
var _StockCount = require("b2b-components/theme/components/StockCount");
var _device = require("b2b-components/utils/device");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _Actions = require("../common/Features/Actions");
var _ImageLink = require("../common/ImageLink");
var _Title = require("../common/Title");
require("./ProductBoxTable.scss");
var ProductBoxTable = function ProductBoxTable(_ref) {
  var basePrice = _ref.basePrice,
    className = _ref.className,
    imageUrl = _ref.imageUrl,
    manufacturerSku = _ref.manufacturerSku,
    onProductClick = _ref.onProductClick,
    price = _ref.price,
    sku = _ref.sku,
    renderSku = _ref.renderSku,
    stock = _ref.stock,
    title = _ref.title,
    dataAttributes = _ref.dataAttributes,
    _ref$deviceType = _ref.deviceType,
    deviceType = _ref$deviceType === void 0 ? _device.DEVICE_TYPE.desktop : _ref$deviceType,
    _ref$isSpecialOrder = _ref.isSpecialOrder,
    isSpecialOrder = _ref$isSpecialOrder === void 0 ? false : _ref$isSpecialOrder,
    _ref$renderActions = _ref.renderActions,
    renderActions = _ref$renderActions === void 0 ? null : _ref$renderActions,
    _ref$renderHiddenPric = _ref.renderHiddenPrice,
    renderHiddenPrice = _ref$renderHiddenPric === void 0 ? null : _ref$renderHiddenPric,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      sku: 'SKU',
      manufacturerSku: 'Manufacturer SKU',
      category: 'Category',
      variants: 'Also available in:',
      "new": 'new',
      promotion: 'promotion',
      sellout: 'sellout',
      occasion: 'occasion',
      coreAssortment: 'Core Assortment',
      ownAssortment: 'Customer specific assortment',
      stockCount: {
        date: '',
        deliveryDates: '',
        notReadyForShipment: '',
        orderedQuantity: '',
        readyForShipment: '',
        specialOrder: {
          full: '',
          "short": '',
          explanation: ''
        },
        seeMore: ''
      }
    } : _ref$text,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '#' : _ref$url,
    _ref$quantityOrdered = _ref.quantityOrdered,
    quantityOrdered = _ref$quantityOrdered === void 0 ? null : _ref$quantityOrdered,
    isMouseOver = _ref.isMouseOver,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  var BasePrice = ProductBoxTable.BasePrice,
    StockCount = ProductBoxTable.StockCount,
    ImageLink = ProductBoxTable.ImageLink,
    Title = ProductBoxTable.Title,
    Price = ProductBoxTable.Price;
  var rootClassName = (0, _classnames["default"])('cds-ProductBoxTable-BodyRow', {
    'cds-ProductBoxTable--Hover': isMouseOver
  }, className);
  return /*#__PURE__*/_react["default"].createElement("tr", (0, _extends2["default"])({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement(ImageLink, {
    sku: sku,
    url: url,
    title: title,
    imageUrl: imageUrl,
    onClick: onProductClick
  })), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-ProductBox-ProductSKU"
  }, (renderSku === null || renderSku === void 0 ? void 0 : renderSku(sku)) || sku)), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-ProductBox-ManufacturerSKU"
  }, (renderSku === null || renderSku === void 0 ? void 0 : renderSku(manufacturerSku)) || manufacturerSku)), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement(Title, {
    sku: sku,
    url: url,
    title: title,
    className: "cds-ProductBoxTable-Text cds-ProductBoxTable-Title",
    onClick: onProductClick
  })), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell cds-ProductBoxTable-BodyCell--Price"
  }, renderHiddenPrice, !renderHiddenPrice && /*#__PURE__*/_react["default"].createElement(Price, {
    price: price,
    size: Price.config.size.small
  }), basePrice && /*#__PURE__*/_react["default"].createElement(BasePrice, {
    unit: basePrice.unit,
    price: basePrice.price
  })), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell cds-ProductBoxTable-BodyCell--Stock"
  }, /*#__PURE__*/_react["default"].createElement(StockCount, {
    className: "cds-ProductBox-StockCount",
    deviceType: deviceType,
    isSpecialOrder: isSpecialOrder,
    quantityOrdered: quantityOrdered,
    stockCount: stock,
    text: text.stockCount
  })), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement(_Actions.Actions, {
    areActionsVisible: isMouseOver
  }, renderActions)));
};
exports.ProductBoxTable = ProductBoxTable;
ProductBoxTable.StockCount = _StockCount.StockCount;
ProductBoxTable.ImageLink = _ImageLink.ImageLink;
ProductBoxTable.Title = _Title.Title;
ProductBoxTable.BasePrice = _BasePrice.BasePrice;
ProductBoxTable.Price = _Price.Price;
ProductBoxTable.Actions = _Actions.Actions;